// tslint:disable:no-unsafe-any (autogenerated)
import { getAuthInstance } from './create-auth-root';
import { getStyles } from './get-styles';
import { checkUserAuth } from './check-user-auth';
import bootstrapLog from './bootstrap-log';
import settingsStore from '../../services/settings/settings-store';
import './styles.less';

let appInitialized = false;
if (typeof window !== 'undefined') {
    // tslint:disable-next-line:no-string-literal (autogenerated)
    window['PRIVATE_CAMERAS_APP_IS_AUTH_PAGE'] = true;
}

export async function initAuth(): Promise<void> {
    if (!appInitialized) {
        try {
            bootstrapLog('init', 'Application initializing....');

            const auth = await checkUserAuth();
            if (auth.success) {
                if (auth.redirectTo && typeof window !== 'undefined') {
                    window.location.replace(auth.redirectTo);
                } else {
                    preLoadMainApp();
                    startApp();
                    return;
                }
            }
            await getStyles();
            await getAuthInstance();
            document.title = settingsStore.getIntlMessage('js.auth.window.title');
            preLoadMainApp();
            bootstrapLog('init', 'Application initialized!');
        } catch (error) {
            bootstrapLog('init', 'Critical error:' + error.toString());
            console.error('AUTH CRITICAL ERROR!' + error.toString(), error);
        }
        appInitialized = true;
    }
}

function log(info: string): void {
    if (NODE_ENV !== 'development') {
        return;
    }
    console.log(info);
}

function preLoadMainApp(): void {
    if (typeof window === 'undefined') {
        return;
    }
    log('PRELOADING APP...');
    let appCallback: Function;
    // tslint:disable-next-line:no-string-literal (autogenerated)
    window['PRIVATE_CAMERAS_APP_DELAY_RUN'] = callback => {
        log('APP DELAYED');
        appCallback = callback;
    };
    // tslint:disable-next-line:no-string-literal (autogenerated)
    window['PRIVATE_CAMERAS_APP_START'] = () => {
        log('STARTING APP...');
        if (appCallback) {
            appCallback();
        }
        // tslint:disable-next-line:no-string-literal (autogenerated)
        delete window['PRIVATE_CAMERAS_APP_DELAY_RUN'];
        // tslint:disable-next-line:no-string-literal (autogenerated)
        delete window['PRIVATE_CAMERAS_APP_START'];
    };
    function isOldIE(): boolean {
        const myNav = window.navigator.userAgent.toLowerCase();
        return myNav.indexOf('msie') >= 0 && parseInt(myNav.split('msie')[1], 10) < 9;
    }
    const tagName = '/assets/private-cameras/index' + (isOldIE() ? '-with-polyfills.js' : '.js');
    const script = document.createElement('script');
    script.src = tagName;
    document.getElementsByTagName('body')[0].appendChild(script);
}

export function startApp(): void {
    if (typeof window === 'undefined') {
        return;
    }
    // tslint:disable-next-line:no-string-literal (autogenerated)
    if (window['PRIVATE_CAMERAS_APP_START']) {
        // tslint:disable-next-line:no-string-literal (autogenerated)
        window['PRIVATE_CAMERAS_APP_START']();
        if (window.history) {
            window.history.pushState({}, '', '/');
        }
    }
}

export async function delayedStart(): Promise<{} | void> {
    // tslint:disable-next-line:no-string-literal (autogenerated)
    if (window['PRIVATE_CAMERAS_APP_DELAY_RUN']) {
        log('DELAYING APP...');
        // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
        return new Promise(resolve => {
            // tslint:disable-next-line:no-string-literal (autogenerated)
            window['PRIVATE_CAMERAS_APP_DELAY_RUN'](resolve);
        });
    }
    return Promise.resolve();
}
